export enum RegionTypes {
  'ctprvn' = 'ctprvn',
  'sig' = 'sig',
  'emd' = 'emd',
}

export enum GeoDataType {
  Sido = 'Sido',
  Sgg = 'Sgg',
  Emd = 'Emd',
}

export enum AddressKey {
  placeName = 'placeName',
  roadAddressName = 'roadAddressName',
  addressName = 'addressName',
}
